import { Divider } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "../../../../redux/Store";
import { commonActions } from "../../../../redux/reducers/CommonReducer";
import { INPUTS_PROPS } from "../../../../enums/Enums";
import Icons from "../../../../resources/icons/Icons";
import Strings from "../../../../resources/Strings";
import {
  getErrorMessage,
  isPhoneNumber,
  isRequired,
} from "../../../../utils/FormUtils";
import { phoneNumberToSend } from "../../../../utils/CommonUtils";
import MessageCard from "../../Cards/MessageCard/MessageCard";
import SelectedTokenCard from "../../Cards/SelectedTokenCard/SelectedTokenCard";
import ParkingAllocationRadioButtons from "../../RadioButtons/ParkingAllocationRadioButtons";
import CustomTooltip from "../../Tooltip/CustomTooltip/CustomTooltip";
import classes from "../CustomInputs.module.css";
//import VerificationPhoneInput from "../CustomInputs/VerificationPhoneInput";
import PhoneInputWithoutVerification from "../CustomInputs/PhoneInputWithoutVerification";

const ExistingAllocationInputWithoutVerification = (props) => {
  const sites = useSelector((state) => state.user.sites);
  const [exsitingAllocationPhone, setExsitingAllocationPhone] = useState("");
  const [existingAllocationDialingCode, setExistingAllocationDialingCode] =
    useState(props.dialingCode);
  const [isPhoneConfirm, setIsPhoneConfirm] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [cardErrorMessage, setCardErrorMessage] = useState("");
  const [exsitingUserTokens, setExsitingUserTokens] = useState([]);
  const [isAssignedSuccess, setIsAssignedSuccess] = useState(false);
  const [hasMultipleAllocations, setHasMultipleAllocations] = useState(false);
  const [tokenOccupiedUserName, setTokenOccupiedUserName] = useState("");
  const selectedSites = sites.filter((site) => site.Id === props.siteid);

  useEffect(() => {
    if (props.handleError) {
      props.handleError({ [props.id]: props.hasError });
    }
  }, [exsitingAllocationPhone]);

  const handlePhoneChange = (event) => {
    // fix - validate that the change update only phoneNumber - on every phone digit keystroke
    if (Object.keys(event)[0] === INPUTS_PROPS.PHONE_NUMBER) {
      setExsitingAllocationPhone(event[INPUTS_PROPS.PHONE_NUMBER]);
    }

    // when switching dialing code - set the selected one and clear phone number input
    if (Object.keys(event)[0] === INPUTS_PROPS.DIALING_CODE) {
      //props.handleChange({[INPUTS_PROPS.DIALING_CODE] : event[INPUTS_PROPS.DIALING_CODE]});
      setExistingAllocationDialingCode(event[INPUTS_PROPS.DIALING_CODE]);
      setExsitingAllocationPhone(""); // clear phone number input
    }

    // sets the dialing code in formData and clears phone number input
    // isAddAllocationProcess - when started from add new parker form and later on choosing existing allocation - value is undefined
    // checking if true - prevents changing the user's phone in the summary step at parker formData
    // (in case started from add new parker)
    // if (Object.keys(event)[0] === INPUTS_PROPS.DIALING_CODE && props.isAddAllocationProcess === true) {
    //   props.handleChange({[INPUTS_PROPS.DIALING_CODE] : event[INPUTS_PROPS.DIALING_CODE]});
    //   setExsitingAllocationPhone(""); // clear phone number input
    // }
  };
  const handleConfirmPhone = () => {
    setIsPhoneConfirm(true);
  };

  // handle Search
  const handlePhoneSearch = (data) => {
    // data may receive error messages, if not continue for allocation retrieval & set on ui
    if (data?.utronUser) {
      // filtered to site tokens
      let currentUserTokens = data?.utronUser?.carUserTokens.filter(
        (carUserToken) => 
        carUserToken?.token?.siteId === props.siteId &&
        !carUserToken?.token.deleted
      );

      // identify if there is difference between requesting user userTypes token and the
      // searched user type tokens (different user type case)
      let carUserTokensForSiteLen = currentUserTokens.length;     

      // filtered to relevant tokens
      currentUserTokens = data?.utronUser?.carUserTokens.filter(
        (carUserToken) => 
        carUserToken?.token?.userTypeId === props.userTypeId &&
        carUserToken?.token?.siteId === props.siteId &&
        !carUserToken?.token.deleted
      );

      // saves the relevant initial car user tokens length (and before filter if given any)
      let relevantCurrentUserTokensLen = currentUserTokens.length;
      let isNoMoreAllocations = false;

      // use filter if has any items passed
      if (props?.filterBy?.length > 0) {
        currentUserTokens = currentUserTokens.filter(token => props.filterBy.every(fbt => fbt.tokenId !== token.tokenId));

        // indicate no tokens after filter
        if (currentUserTokens.length === 0) {
          // check if all searched user's tokens contained in the requesting user tokens list, and searched user doesnt have any initial tokens before
          isNoMoreAllocations = currentUserTokens.map(token => token.tokenId).every(token => props.filterBy.map(fbt => fbt.tokenId).includes(token)) && relevantCurrentUserTokensLen > 0;
        }
      }

      if (currentUserTokens.length === 0) {       
        if (isNoMoreAllocations) {
          // requesting user added all the allocations that founded on the 
          // searched user and there is no remaining free allocations
          setCardErrorMessage(Strings.NO_FREE_PARKING_ALLOCATIONS_WERE_FOUND);
        } else if (carUserTokensForSiteLen > 0) {
          // searched user has different user type tokens
          setCardErrorMessage(Strings.ALLOCATION_DIFFERENT_USER_TYPE);
        } else {
          // no parking allocation was found on the searched user
          setCardErrorMessage(Strings.NO_PARKING_ALLOCATION_WAS_FOUND);
        }
               
        setShowErrorMessage(true);
      } else if (currentUserTokens.length === 1) {
        handleSelectedToken(currentUserTokens[0]);
      } else {
        // set the existing tokens list, tokens associated with cars will be presented first  
        setExsitingUserTokens(currentUserTokens.sort((a, b) => b.carId - a.carId));
        setHasMultipleAllocations(true); 

        // set the founded existing parker that the tokens belong to
        props.handleChange({ ["foundedExistingParker"]: data.utronUser });
      }
      setTokenOccupiedUserName(
        data?.utronUser?.firstName + " " + data?.utronUser?.lastName
      );
    } else {
      // Not founded message & try again button
      setCardErrorMessage(data);
      setShowErrorMessage(true);
    }



    // let phoneNumber = existingAllocationDialingCode + phoneNumberToSend(existingAllocationDialingCode, exsitingAllocationPhone);
    // actionsService.validatePhoneNumber(phoneNumber).then(response => {
    //     if (response.data.isSuccess) {
    //         data = response.data.entity;
    //         if (data?.utronUser) {
    //             let currentUserTokens = data?.utronUser?.carUserTokens.filter(
    //               (carUserToken) => carUserToken?.token?.siteId === props.siteId
    //             );
          
    //             let carUserTokensForSiteLen = currentUserTokens.length;
    //             currentUserTokens = currentUserTokens.filter(
    //               (carUserToken) =>
    //                 // carUserToken?.isOccupied &&
    //                 carUserToken?.token?.userTypeId === props.userTypeId &&
    //                 carUserToken?.token?.isBillingEnabled === props.isPaying
    //             );
    //             if (currentUserTokens.length === 0) {
    //               // No parking allocation was found
    //               if (carUserTokensForSiteLen > 0) {
    //                 setCardErrorMessage(Strings.ALLOCATION_DIFFERENT_USER_TYPE);
    //               } else {
    //                 setCardErrorMessage(Strings.NO_PARKING_ALLOCATION_WAS_FOUND);
    //               }
    //               setShowErrorMessage(true);
    //             } else if (currentUserTokens.length === 1) {
    //               handleSelectedToken(currentUserTokens[0]);
    //             } else {
    //               // set the existing tokens list
    //               setExsitingUserTokens(currentUserTokens);
    //               setHasMultipleAllocations(true);

    //               // set the founded existing parker that the tokens belong to
    //               props.handleChange({["foundedExistingParker"] : data.utronUser});
    //             }
    //             setTokenOccupiedUserName(
    //               data?.utronUser?.firstName + " " + data?.utronUser?.lastName
    //             );
    //           } else {
    //             // Not founded message & try again button
    //             setCardErrorMessage(data);
    //             setShowErrorMessage(true);
    //           }
    //     }
    //     else {
    //         // Not founded message & try again button
    //         setCardErrorMessage(data);
    //         setShowErrorMessage(true);
    //     }
    // })
    // .catch((error) => {
    //   console.log(error);
    // });


    // if (data?.utronUser) {
    //   let currentUserTokens = data?.utronUser?.carUserTokens.filter(
    //     (carUserToken) => carUserToken?.token?.siteId === props.siteId
    //   );

    //   let carUserTokensForSiteLen = currentUserTokens.length;
    //   currentUserTokens = currentUserTokens.filter(
    //     (carUserToken) =>
    //       // carUserToken?.isOccupied &&
    //       carUserToken?.token?.userTypeId === props.userTypeId &&
    //       carUserToken?.token?.isBillingEnabled === props.isPaying
    //   );
    //   if (currentUserTokens.length === 0) {
    //     // No parking allocation was found
    //     if (carUserTokensForSiteLen > 0) {
    //       setCardErrorMessage(Strings.ALLOCATION_DIFFERENT_USER_TYPE);
    //     } else {
    //       setCardErrorMessage(Strings.NO_PARKING_ALLOCATION_WAS_FOUND);
    //     }
    //     setShowErrorMessage(true);
    //   } else if (currentUserTokens.length === 1) {
    //     handleSelectedToken(currentUserTokens[0]);
    //   } else {
    //     setExsitingUserTokens(currentUserTokens);
    //     setHasMultipleAllocations(true);
    //   }
    //   setTokenOccupiedUserName(
    //     data?.utronUser?.firstName + " " + data?.utronUser?.lastName
    //   );
    // } else {
    //   setCardErrorMessage(data);
    //   setShowErrorMessage(true);
    // }
  };

  const handleClickAgain = () => {
    setShowErrorMessage(false);
  };

  const handleSelectedToken = (token) => {
    props.handleAssignTokenToFob(token);
    // setHasMultipleAllocations(false);

    // allocation add
    store.dispatch(commonActions.setShowAddNewUserButton(true));
    store.dispatch(commonActions.setShowAdditionalParkingAllocationButton(true));

    setIsAssignedSuccess(true);
  };

  const existingPhoneNumberValidation = () => {
    //return  existingAllocationDialingCode + exsitingAllocationPhone !== props?.userData?.phoneNumber && phoneNumberToSend(exsitingAllocationPhone) !== props?.userData?.phoneNumber
    return (
      existingAllocationDialingCode +
        phoneNumberToSend(
          existingAllocationDialingCode,
          exsitingAllocationPhone
        ) !==
      (props?.userData?.phoneNumber || props?.dialingCode + props?.phoneNumber)
    );
  };

  return (
    <div className={classes.customTextField}>
      {(/*props.occupiedTokens?.length > 0 || */
        (!showErrorMessage &&
          !isAssignedSuccess) /* && !hasMultipleAllocations */) && (
        <div className={classes.codeVerification}>
          {!props.isFobSkipped &&
            (/*props.occupiedTokens?.length > 0 ||*/ !isAssignedSuccess) && (
              <>
                <SelectedTokenCard
                  text={props.skipFob ? Strings.FOB_SKIPPED : `${Strings.SCAN_FOB_SUCCESS}: ${props.fobId}`}
                  handleDelete={props.handleDeleteFob}
                  isAssignedSuccess={isAssignedSuccess}
                />
                <Divider />
              </>
            )}
          {/* {!props.isFobSkipped && (props.occupiedTokens?.length > 0 || props.fobId !== '') &&  <Divider />} */}
          {/*<Divider />*/}
          {!showErrorMessage &&
            !isAssignedSuccess &&
            !hasMultipleAllocations && (
              <span className={classes.verificationMessage}>
                {Strings.SEARCH_EXSISTING_ALLOCATION_MESSAGE}
                <CustomTooltip
                  tooltipTitle={
                    Strings.TOOLTIP_INFO_TITLE.SEARCH_PARKING_ALLOCATION
                  }
                  tooltipText={
                    Strings.TOOLTIP_INFO_TEXT.SEARCH_PARKING_ALLOCATION
                  }
                ></CustomTooltip>
              </span>
            )}
          {!showErrorMessage &&
            !isAssignedSuccess &&
            !hasMultipleAllocations && (
              <div className={classes.action}>
                <PhoneInputWithoutVerification 
                     validateExsistingUser={true}
                     label={Strings.INPUT_LABELS.PHONE_NUMBER}
                     value={exsitingAllocationPhone}
                     actionText={Strings.SEARCH}
                     id={INPUTS_PROPS.PHONE_NUMBER}
                     isPhoneVerified={props.isPhoneVerified}
                     dialingCode={existingAllocationDialingCode}
                     onChange={handlePhoneChange}
                     //handleError={handleError}
                     isStepSubmitted={isPhoneConfirm}
                     hasError={
                       !isRequired(exsitingAllocationPhone).isValid ||
                       !isPhoneNumber(
                         existingAllocationDialingCode +
                           phoneNumberToSend(
                             existingAllocationDialingCode,
                             exsitingAllocationPhone
                           )
                       ).isValid
                     }
                     errorMessage={
                       getErrorMessage(isRequired(exsitingAllocationPhone))
                         ? getErrorMessage(isRequired(exsitingAllocationPhone))
                         : getErrorMessage(
                             isPhoneNumber(
                               existingAllocationDialingCode +
                                 phoneNumberToSend(
                                   existingAllocationDialingCode,
                                   exsitingAllocationPhone
                                 )
                             )
                           )
                     }
                     handleVerify={handlePhoneSearch}
                     selectedSiteId={props.siteId}
                     selectedSites={selectedSites}
                     isAddAllocationProcess={props.isAddAllocationProcess}
                     existingPhoneNumberValidation={existingPhoneNumberValidation}
                />
                {/* <VerificationPhoneInput
                  validateExsistingUser={true}
                  label={Strings.INPUT_LABELS.PHONE_NUMBER}
                  value={exsitingAllocationPhone}
                  actionText={Strings.SEARCH}
                  id={INPUTS_PROPS.PHONE_NUMBER}
                  isPhoneVerified={props.isPhoneVerified}
                  dialingCode={existingAllocationDialingCode}
                  onChange={handlePhoneChange}
                  //handleError={handleError}
                  isStepSubmitted={isPhoneConfirm}
                  hasError={
                    !isRequired(exsitingAllocationPhone).isValid ||
                    !isPhoneNumber(
                      existingAllocationDialingCode +
                        phoneNumberToSend(
                          existingAllocationDialingCode,
                          exsitingAllocationPhone
                        )
                    ).isValid
                  }
                  errorMessage={
                    getErrorMessage(isRequired(exsitingAllocationPhone))
                      ? getErrorMessage(isRequired(exsitingAllocationPhone))
                      : getErrorMessage(
                          isPhoneNumber(
                            existingAllocationDialingCode +
                              phoneNumberToSend(
                                existingAllocationDialingCode,
                                exsitingAllocationPhone
                              )
                          )
                        )
                  }
                  handleVerify={handleVerifyPhone}
                  // hasError={!isPhoneNumber(exsitingAllocationPhone).isValid}
                  //setPhoneNumberError={setPhoneNumberError}
                  //helperText={"test"}
                  //errorMessage={phoneNumberError?.errorMessage}
                  // errorMessage={getErrorMessage(
                  //   isPhoneNumber(exsitingAllocationPhone)
                  // )}
                  selectedSiteId={props.siteId}
                  selectedSites={selectedSites}
                  isAddAllocationProcess={props.isAddAllocationProcess}
                  existingPhoneNumberValidation={existingPhoneNumberValidation}
                /> */}
              </div>
            )}
          {hasMultipleAllocations && (
            <div>
              <span className={classes.verificationMessage}>
                {tokenOccupiedUserName} has multiple parking allocations. Choose
                the one you would like to assigne the FOB
                {/* {Strings.SEAECH_EXSISTING_ALLOCATION_MESSAGE} */}
              </span>
              <ParkingAllocationRadioButtons
                occupiedTokens={exsitingUserTokens}
                handleSelectedToken={handleSelectedToken}
              />
            </div>
          )}
          {/* {showErrorMessage && (
          <MessageCard
            icon={Icons.ATTENTION}
            title="Pay Attention"
            text="No parking allocation found"
            buttonText="Try Again"
            clickHandler={handleClickAgain}
          />
        )} */}
          {isAssignedSuccess && /*props.occupiedTokens?.length > 0 &&*/ (
            <span className={classes.verificationMessage}>
              Parking allocation was found. Assigned to {tokenOccupiedUserName}
              {/* {Strings.SEAECH_EXSISTING_ALLOCATION_MESSAGE} */}
            </span>
          )}
          {/* {!isVerifiy && (
      <div className={classes.error}>{verifiyErrorMessage}</div>
    )} */}
        </div>
      )}
      {/*!props.occupiedTokens?.length > 0 &&*/ showErrorMessage && (
        <div className={classes.codeVerification}>
          <MessageCard
            icon={Icons.ATTENTION}
            title={Strings.SORRY}
            text={cardErrorMessage}
            buttonText={Strings.TRY_AGAIN}
            clickHandler={handleClickAgain}
          />
        </div>
      )}
    </div>
  );
};

export default ExistingAllocationInputWithoutVerification;
